<label class="lg-container">
  <input type="radio" name="color" [value]=color [formControl]="control">
  <span class="checkmark" [style.background]="backgroundColor"></span>
</label>
